import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  retentionService,
  type SaveRetentionPolicyInput,
} from '../retentionService';
import type { RetentionResource } from '../../../types/retention';

/** Saved retention policies plus the cleanup schedule. */
export function useRetentionPolicies(enabled = true) {
  return useQuery({
    queryKey: ['retentionPolicies'],
    queryFn: () => retentionService.getRetentionPolicies(),
    staleTime: 60000,
    enabled,
  });
}

/**
 * Save the retention window for a resource. Renders its own toast, so the
 * global one is hidden.
 */
export function useSaveRetentionPolicy() {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { hideToast: true },
    mutationFn: ({
      resource,
      ...data
    }: SaveRetentionPolicyInput & { resource: RetentionResource }) =>
      retentionService.saveRetentionPolicy(resource, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['retentionPolicies'] });
    },
  });
}
